/**
 * @file scripts/components/user/cookies.js
 * @description
 * This is our cookie manager (clever name!), using the basic cookie node
 * module for parsing/serializing and providing some simple get and set
 * functionality for handling FFT cookies.
 */
import cookie from 'cookie';

// placeholder for our internal cookie jar
let _cookies;


//
// ============================================================================
// Private methods
//

//
// Simple method for re/parsing our cookie stash.
//
function refresh() {
    _cookies = cookie.parse(document.cookie);
}

// auto-refresh on initial load
refresh();


const cookies = {
    //
    // ============================================================================
    // Public methods
    //  


    //
    // A simple setter for stashing cookies. You can give it a simple key
    // and value as params to set a single cookie, or feed it an object
    // of key/val pairs to set multiple cookies at once
    //
    set: (toCookie, val) => {
        var 
            key,
            keys, 
            i, 
            n;

        // were we given a single key/single val? easy
        if (typeof toCookie === 'string') {
            document.cookie = cookie.serialize(toCookie, val, {path: '/'});

        // if we're handling multiple values, it's a bit trickier
        } else {
            keys = Object.keys(toCookie);
            for (i = 0, n = keys.length; i < n; i++) {
                key = keys[i];
                document.cookie = cookie.serialize(key, toCookie[key], {path: '/'});
            }
        }

        refresh();
    },

    //
    // A simple getter for grabbing an (assumed) cookie.
    //
    get: (key) => {

        // if a requested cookie isn't found, reparse to update our cache
        if (typeof _cookies[key] === 'undefined') {
            // reparse our internal cache
            refresh();

        }
        
        return (_cookies[key] === '') ? undefined : _cookies[key];
    },

    //
    // An unsetter for destroying/expring a given cookie.
    //
    unset: (key) => {
        delete _cookies[key];
        document.cookie = cookie.serialize(
            key, 
            '',
            {expires: new Date('1970-01-01T00:00:01')}
        );
        refresh();
    }
};

export default cookies;